/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { LargeFeedFilter } from "cms/shared/feeds/large";

const Advisories = () => {

    const type = "model.notice"; //todo: change to advisories

    return (
        <main>
            <h1 style={{ marginTop: "16px" }}>Advisories</h1>

            <div className='last-updated-rule'></div>

            <LargeFeedFilter
                type={type} enableBar={true}
            />

        </main>
    );
};

export { Advisories };
